import { LOCIZE_NS } from '@avanta/shared/constants/common';
import { Trans } from 'react-i18next';

export const WelcomeMessage = (): React.ReactElement => (
  <div className="flex gap-2 mb-4 justify-center w-full max-w-full am-lg:max-w-140 mx-auto text-plum-400 text-xs text-center leading-4">
    <Trans
      i18nKey="Chat.welcomeMessage.supporter"
      ns={LOCIZE_NS.CHAT}
      components={{
        br: <br className="hidden md:inline" />,
      }}
    />
  </div>
);
